<div class="card-sm-wrap" (click)="navigateToDetailsPage()">
    <figure class="image-wrap">
        <img class="image" src="{{report?.s3UrlImage? report.s3UrlImage :'../../../../assets/images/content.jpg'}}" />
    </figure>
    <div class="wrap-text">
        <span class="tag-name tag-industry" [ngClass]="report?.category === 'IND_REPORT' ? 'tag-industry' : 'tag-funding'">{{getLabelByCode(report?.category)}} </span>
        <h6 class="cat-title">{{getTrimValue(report?.title,50)}}</h6>
    </div>
</div>
